export default "__VITE_ASSET__3lHGUVbi__"